export enum BUILD_MODE {
  DEV = 'dev',
  PRODUCTION = 'production',
}

export const IS_PRODUCTION = process.env.NODE_ENV === 'production'
export const NEXT_PUBLIC_BUILD_MODE = process.env.NEXT_PUBLIC_BUILD_MODE || BUILD_MODE.DEV

export const NEXT_PUBLIC_API_URL = process.env.NEXT_PUBLIC_API_URL || ''
export const NEXT_PUBLIC_AUTH_API_URL = process.env.NEXT_PUBLIC_AUTH_API_URL || ''
export const NEXT_PUBLIC_BUYXSHARE_API_URL = process.env.NEXT_PUBLIC_BUYXSHARE_API_URL || ''

export const STAMP_PRINT_API_KEY = process.env.STAMP_PRINT_API_KEY || ''
// Print-tool target. Falls back to the global Buyxshare base so the rest of the
// app stays on staging; set this to the local server (e.g. http://localhost:3001/api)
// when testing the unreleased stamp endpoint.
export const STAMP_PRINT_API_BASE =
  process.env.STAMP_PRINT_API_BASE || NEXT_PUBLIC_BUYXSHARE_API_URL

export const NEXT_PUBLIC_SITE_URL = process.env.NEXT_PUBLIC_SITE_URL || 'http://localhost:3000'
export const NEXT_PUBLIC_SITE_NAME = process.env.NEXT_PUBLIC_SITE_NAME || ''

export const NEXT_PUBLIC_TENANT_ID = process.env.NEXT_PUBLIC_TENANT_ID || ''
export const NEXT_PUBLIC_COUNTRY_ID = process.env.NEXT_PUBLIC_COUNTRY_ID || ''
export const NEXT_PUBLIC_COUNTRY_NAME = process.env.NEXT_PUBLIC_COUNTRY_NAME || ''

export const NEXT_PUBLIC_VIET_QR_URL = process.env.NEXT_PUBLIC_VIET_QR_URL || ''
export const NEXT_PUBLIC_USE_VIET_QR_API = process.env.NEXT_PUBLIC_USE_VIET_QR_API || 'false'
export const NEXT_PUBLIC_LANDINGPAGE_URL = process.env.NEXT_PUBLIC_LANDINGPAGE_URL || ''
// Base URL the stamp QR points at (<host>/nv/<token>, scheme stripped for the printed
// QR). Runtime env so each environment can set its own host WITHOUT a rebuild; falls
// back to the landing URL.
export const STAMP_LINK_BASE =
  process.env.STAMP_LINK_BASE || NEXT_PUBLIC_LANDINGPAGE_URL

export const NEXT_PUBLIC_APP_SCHEME = process.env.NEXT_PUBLIC_APP_SCHEME || ''
export const NEXT_PUBLIC_IOS_STORE_URL = process.env.NEXT_PUBLIC_IOS_STORE_URL || ''
export const NEXT_PUBLIC_ANDROID_STORE_URL = process.env.NEXT_PUBLIC_ANDROID_STORE_URL || ''
// buyxshare-seller's own store listings — separate app ("BuyXShare NPP"),
// separate store pages. iOS verified live 2026-09-09
// (apps.apple.com/vn/app/id6799811064). Android is the deterministic Play
// Store URL for the app's real package id (com.hubcom.buyxshareseller) —
// NOT yet confirmed live (Android signing secrets aren't provisioned in
// release-seller.yml yet), but the URL shape is fixed by the package id,
// not guessed, so it's wired up now and will resolve once that listing
// publishes.
export const NEXT_PUBLIC_SELLER_IOS_STORE_URL =
  process.env.NEXT_PUBLIC_SELLER_IOS_STORE_URL ||
  'https://apps.apple.com/vn/app/buyxshare-npp/id6799811064'
export const NEXT_PUBLIC_SELLER_ANDROID_STORE_URL =
  process.env.NEXT_PUBLIC_SELLER_ANDROID_STORE_URL ||
  'https://play.google.com/store/apps/details?id=com.hubcom.buyxshareseller'
// Custom scheme registered by buyxshare-seller (ios/Runner/Info.plist,
// android/app/.../AndroidManifest.xml).
export const NEXT_PUBLIC_SELLER_APP_SCHEME =
  process.env.NEXT_PUBLIC_SELLER_APP_SCHEME || 'buyxshareseller://'
export const NEXT_PUBLIC_PRODUCT_PAGE_URL = process.env.NEXT_PUBLIC_PRODUCT_PAGE_URL || ''
export const NEXT_PUBLIC_PHONE_NUMBER = process.env.NEXT_PUBLIC_PHONE_NUMBER || ''
export const NEXT_PUBLIC_CONTACT_EMAIL = process.env.NEXT_PUBLIC_CONTACT_EMAIL || ''

// App-association files (server-only, never shipped to the browser).
export const APPLE_APP_ID = process.env.APPLE_APP_ID || ''
export const ANDROID_PACKAGE = process.env.ANDROID_PACKAGE || 'com.hubcom.buyxsharemobile'
export const ANDROID_SHA256 = process.env.ANDROID_SHA256 || ''
